import { welcomeKitData } from "./programWelcomeKit.data";
import { ProgramWelcomeKit } from "./ProgramWelcomeKit";

export type Props = {
  /** Callback when a download button is clicked */
  onDownload?: () => void;
};

export function ProgramWelcomeKitContainer({ onDownload }: Props) {
  return (
    <ProgramWelcomeKit
      data={welcomeKitData}
      title="Social Media Kit"
      description="We welcome you to use the below copy and assets to announce your participation in the Pollinator program."
      onDownload={onDownload}
    />
  );
}

export default ProgramWelcomeKitContainer;

